











import { Vue, Component } from 'vue-property-decorator';
import BottomTabbarNew from './components/BottomTabbarNew.vue';
import Banner from '@/components/Banner.vue';
import * as config from './config';
import { getBaseinfo } from '@/api/api';

@Component({
  components: {
    Banner,
    BottomTabbarNew,
  },
})
export default class Home extends Vue {
  banner = require('./img/banner.jpg');
  option = config.OPTHINES;
  async created() {
    const res = await getBaseinfo(this.option.voteName);
    this.banner = res.data.banner;
    this.$addPv(res.data.activityId);
  }
}
